import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { WelcomePageLayout } from '@thinknet-gmbh/platform-common-ui';
import { PlatformModulesEnum } from '@thinknet-gmbh/platform-common';

import { ROUTES } from 'src/components/app/app-routes.constants';
import { useGetCurrentAccount } from 'src/hooks/accounts/get-current-account.hook';
import { useUpdateCurrentProfile } from 'src/hooks/profiles/update-current-profile.hook';
import { useSendChangeEmailLink } from 'src/hooks/accounts/send-change-email-link.hook';
import { useUpdateCurrentCompany } from 'src/hooks/companies/update-current-company.hook';
import { useGetCurrentMemberAccount } from 'src/hooks/accounts/get-current-member-account.hook';
import { useGetCurrentSubscription } from 'src/hooks/subscriptions/get-current-subscription.hook';

import { IFormData } from './welcome.interfaces';

const WelcomePage = () => {
  const {
    profile,
    account: { email },
    loading,
  } = useGetCurrentAccount();

  const { member } = useGetCurrentMemberAccount();

  const { subscription } = useGetCurrentSubscription({ skipSubscription: true });

  const [data, setData] = useState<IFormData | null>(null);

  useEffect(() => {
    if (!loading && !data && subscription.subscriptionType) {
      setData({
        firstName: profile.firstName,
        lastName: profile.lastName,
        email,
        phoneNumber: profile.phoneNumber,
        companyName: member.ownerCompany.name,
        subscriptionType: subscription.subscriptionType,
      });
    }
  }, [data, profile, email, loading, member, subscription]);

  const navigate = useNavigate();
  const { t } = useTranslation(['auth', 'customers', 'common']);

  const updateCurrentProfile = useUpdateCurrentProfile();
  const sendChangeEmailLink = useSendChangeEmailLink();
  const updateCurrentCompany = useUpdateCurrentCompany();

  const onSubmitData = () => {
    updateCurrentProfile({
      variables: {
        payload: {
          firstName: data?.firstName,
          lastName: data?.lastName,
          phoneNumber: data?.phoneNumber,
        },
      },
    });

    if (data?.email !== email) {
      sendChangeEmailLink({ variables: { payload: { email: data?.email } } });
    }

    if (data?.companyName) {
      updateCurrentCompany({ variables: { payload: { name: data.companyName } } });
    }

    navigate(ROUTES.dashboard);
  };

  return (
    <WelcomePageLayout
      module={PlatformModulesEnum.PLAN_WERK_MODULE}
      t={t}
      data={data}
      setData={setData}
      onSubmitData={onSubmitData}
    />
  );
};

export default WelcomePage;
